import { createSlice } from "@reduxjs/toolkit";
import { addProductFeaturesAPI } from "../../services/addProductFeatures";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const addProductFeaturesSlice = createSlice({
  name: "addProductFeatures",
  initialState: data,
  reducers: {
    addProductFeaturesInfo(state) {
      state.isLoading = true;
    },
    addProductFeaturesInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    addProductFeaturesInfoFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    addProductFeaturesInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const addProductFeaturesHandler =
  (data, options = {}) =>
  async (dispatch) => {
  try {
    dispatch(addProductFeatureAction.addProductFeaturesInfo());
    const response = await addProductFeaturesAPI(data, options);
    dispatch(addProductFeatureAction.addProductFeaturesInfoSuccess(response));
  } catch (e) {
    const failurePayload =
      e && typeof e === "object" && "message" in e
        ? e
        : { message: e || "Something went wrong." };
    dispatch(addProductFeatureAction.addProductFeaturesInfoFailure(failurePayload));
  }
};
export default addProductFeaturesSlice.reducer;
export const addProductFeatureAction = addProductFeaturesSlice.actions;
